import Dialog from "../../1. Core/Controls/Dialog/Dialog";
import TextField from "../../1. Core/Controls/TextField/TextField";
import {ServerAPI} from "../../1. Core/ServerAPI";
import NP from "../../1. Core/NP";
import Select from "../../1. Core/Controls/Select/Select";


export default class AddUserToTeamDialog extends Dialog {

    private _TeamId: number;
    private _name: TextField;
    private _userRole: Select;

    constructor(props: any) {
        super(props);
    }

    _initFields(settings: object) {
        this._TeamId = null
        super._initFields(settings);
        this._Mode = 'FullHeight';
        this._Caption = 'Edit Team';
        this._CloseOnFrameMouseDown = true;
        this._ShowHeader = true;
        this._ShowCloseButton = true;
        this._OkRK = 'Save';
        this._AutoDestroy = true;
    }

    _render() {
        super._render();

        this._name = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'User Email or ID'
        });

        this._userRole = new Select({
            ParentNode: this._contentNode,
            FloatingLabel: 'User Role',
            Items: [
                {Value: 'user', Content: 'User'},
                {Value: 'admin', Content: 'Admin'},
            ]
        })
    }


    async _onOkButtonClick() {

        try {
            await ServerAPI.post(`/user-teams`, {
                userEmail: this._name.getValue(),
                teamId: this._TeamId,
                role: this._userRole.getValue()
            });
        } catch (error) {
            NP.showMessage({Content: 'User not found'});
            return;
        }


        this.EvOkButtonClick.fire(this);
        this.hide();
    }
}